import { createAsyncThunk } from "@reduxjs/toolkit";

import { type DiscountDocument } from "@fitness-app/data-models/entities/Discount";

import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { getTeamOwnerId } from "../../../helpers/getTeamOwnerId";
import { type AsyncThunkCreator } from "../../../index";
import { DISCOUNT_REDUCER_NAME } from "../types";

type Payload = void;

export const fetchDiscounts = createAsyncThunk<DiscountDocument[], Payload, AsyncThunkCreator<string>>(
  `${DISCOUNT_REDUCER_NAME}/fetchDiscounts`,
  async (_, { rejectWithValue, extra: { db, auth } }) => {
    const currentUser = await getLoggedUser(auth);

    const { error, data } = await db
      .from("discount")
      .select("*")
      .eq("ownerId", getTeamOwnerId(currentUser))
      .order("createdAt", { ascending: false })
      .returns<DiscountDocument[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data;
  },
);
